import { Component, OnInit, inject } from '@angular/core';
import { SynonymerService } from './synonymer.service';
import { NameType } from '../../shared/models/models';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SynonymerEditDialogComponent } from './synonymer-edit-dialog/synonymer-edit-dialog.component';
import { TableColumn, TableConfig } from '../../shared/components/app-table/app-table-models';
import { ButtonSetItem } from '../../shared/components/app-button-set/app-button-set-models';
import { Synonym } from '../../shared/models/synonymer';
import { StatusOptions } from '../models/ignore';
import { AuthorizationService } from 'src/app/auth/services/authorization.service';
import { Role } from '../anvandare/anvandare.models';

@Component({
    selector: 'lib-synonymer',
    templateUrl: './synonymer.component.html',
    styleUrls: ['./synonymer.component.css'],
    standalone: false
})
export class SynonymerComponent implements OnInit {
  private synonymerService = inject(SynonymerService);
  private dialogService = inject(DialogService);
  private authorizationService = inject(AuthorizationService);

  tableConfig = this.getTableConfig();
  ref: DynamicDialogRef | null = null;
  selectedNameType = NameType.Smittamne;

  synonymerTypesButtonSet: ButtonSetItem[] = [
    { text: 'Smittämne', value: NameType.Smittamne, active: true },
    { text: 'Analys', value: NameType.Analys },
    { text: 'Provmaterial', value: NameType.Provmaterial },
    { text: 'Antibiotika', value: NameType.Antibiotika },
    { text: 'Negativt fynd', value: NameType.NegativtFynd },
    { text: 'Beskrivande fynd', value: NameType.BeskrivandeFynd },
  ];

  ngOnInit() {
    this.getSynonymer(this.selectedNameType);
  }

  getTableConfig(): TableConfig {
    return {
      columns: [
        { field: 'synonym', header: 'Synonym', sortByField: 'synonym', columnFilter: 'text' },
        { field: 'name', header: 'Standardnamn', sortByField: 'name', columnFilter: 'text' },
        this.getStatusColumn(),
        { field: 'labb_kod', header: 'Tillhör laboratorium', sortByField: 'labb_kod', columnFilter: 'multi-select' },
        { field: 'modifiedBy', header: 'Modifierad av', sortByField: 'modifiedBy' },
        { field: 'startDate', header: 'Skapad datum', type: 'date', sortByField: 'startDate' },
        {
          field: 'comments',
          header: 'Kommentar',
          sortByField: 'comments',
          type: 'icon',
          icon: 'fas fa-message',
          commentsAsTitle: true,
        },
        this.authorizationService.hasRole([Role.SuperanvandareIntern])
          ? { field: '', header: '', type: 'editButton', click: this.onEdit.bind(this), editableCondition: {field: 'labb_kod', value: null}  }
          : {},
      ],
    };
  }

  onSelect(item: ButtonSetItem) {
    this.selectedNameType = item.value;
    this.getSynonymer(item.value);
  }

  onEdit(synonym: Synonym) {
    const dialogRef = this.dialogService.open(SynonymerEditDialogComponent, {
      header: 'Ändra synonym',
      width: '500px',
      contentStyle: { overflow: 'visible' },
      baseZIndex: 10000,
      maximizable: false,
      data: {
        synonym: { ...synonym },
        nameType: this.selectedNameType,
      },
    });

    if (!dialogRef) {
      return;
    }

    this.ref = dialogRef;

    dialogRef.onClose.subscribe((modifiedSynonym: Synonym) => {
      if (modifiedSynonym) {
        this.updateSynonym(modifiedSynonym);
      }
    });
  }

  async getSynonymer(type: NameType) {
    this.tableConfig.rows = [];
    this.tableConfig.rows = await this.synonymerService.getSynonymer(type);
  }

  async updateSynonym(synonym: Synonym) {
    await this.synonymerService.putSynonym(this.selectedNameType, synonym);
    this.getSynonymer(this.selectedNameType);
  }

  private getStatusColumn(): TableColumn {
    return this.authorizationService.hasRole([Role.SuperanvandareIntern])
      ? {
          field: 'status',
          header: 'Status',
          sortByField: 'status',
          type: 'dropdown',
          dropdownOptions: [
            { value: 'AKTIV', label: 'Aktiv' },
            { value: 'INAKTIV', label: 'Inaktiv' },
          ],
          filterOptions: [
            { name: 'AKTIV', label: 'Aktiv' },
            { name: 'INAKTIV', label: 'Inaktiv' },
          ],
          click: (event: any) => this.updateSynonym(event),
          columnFilter: 'multi-select',
        }
      : {
          field: 'status',
          header: 'Status',
          sortByField: 'status',
          columnFilter: 'multi-select',
          filterOptions: [
            { name: 'AKTIV', label: 'Aktiv' },
            { name: 'INAKTIV', label: 'Inaktiv' },
          ],
        };
  }
}
